import { render, staticRenderFns } from "./selectType.vue?vue&type=template&id=3a4a3e64&scoped=true"
import script from "./selectType.vue?vue&type=script&lang=js"
export * from "./selectType.vue?vue&type=script&lang=js"
import style0 from "./selectType.vue?vue&type=style&index=0&id=3a4a3e64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4a3e64",
  null
  
)

export default component.exports